<template>
  <div
    v-if="value.quantity"
    class="text-xs hover:opacity-70 active:opacity-90 mt-1">
    Vorwoche: {{ value.quantity }} Stk.
  </div>
</template>

<script>
import getISODay from 'date-fns/getISODay'

export default {
  name: 'CopyOrderQuantity',
  props: {
    item: {
      type: Object,
      required: true
    },
    date: {
      type: Date,
      required: true
    }
  },

  data: () => ({
  }),

  computed: {
    calendarWeek() {
      return getISODay(this.date)
    },

    value() {
      return this.item.last_orders_quantities.find(q => q.weekday === this.calendarWeek)
    }
  }
}
</script>
